module.exports = __webpack_public_path__ + "assets/img/branch_icon_disabled.156b33f4.svg";